import { render, staticRenderFns } from "./SeasonTicketRevisionDetails.vue?vue&type=template&id=02303767&"
import script from "./SeasonTicketRevisionDetails.vue?vue&type=script&lang=js&"
export * from "./SeasonTicketRevisionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports